import { render, staticRenderFns } from "./DisplayCategoryExcelBatchRegisterIframe.vue?vue&type=template&id=24877aaa&"
import script from "./DisplayCategoryExcelBatchRegisterIframe.vue?vue&type=script&lang=ts&"
export * from "./DisplayCategoryExcelBatchRegisterIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports